import { render, staticRenderFns } from "./BuscarPlantilla.vue?vue&type=template&id=ae96a39c&scoped=true"
import script from "./BuscarPlantilla.vue?vue&type=script&lang=js"
export * from "./BuscarPlantilla.vue?vue&type=script&lang=js"
import style0 from "./BuscarPlantilla.vue?vue&type=style&index=0&id=ae96a39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96a39c",
  null
  
)

export default component.exports